import dayjs from 'dayjs'
import isToday from 'dayjs/plugin/isToday'
import React from 'react'

import Tip from '@/screens/Credit/page/ui/Tip/Tip'
import { HomeIcon } from '@/screens/Product/page/assets/HomeIcon'
import { PackIcon } from '@/screens/Product/page/assets/PackIcon'
import { PinIcon } from '@/screens/Product/page/assets/PinIcon'

import { RegionSelector } from '@/widgets/RegionSelector'

import { Question } from '@/shared/lib/@deprecated/iport-icons'
import { getLocalDateStringFromUTC } from '@/shared/lib/utils/common/getLocalDateStringFromUTC'
import { scrollToTabSection } from '@/shared/lib/utils/scroll/scrollToTabSection'
import { RegionType } from '@/shared/types/deprecated-types'
import { OrderType } from '@/shared/types/product-types'
import { Button } from '@/shared/ui'
import { Text } from '@/shared/ui'
import Flex from '@/shared/ui/Flex'

import { DeliveryItem } from './components/DeliveryItem/DeliveryItem'

import cl from './product-delivery.module.scss'

dayjs.extend(isToday)

export type DeliveryData = {
	PICKUP: { DATE: string; SHOPS_COUNT: number }
	HOME: { DATE: string; TODAY_PRICE: string; PRICE: number }
	PVZ: boolean
}

export type ProductDeliveryProps = {
	ORDER_TYPE: `${OrderType}`
	DELIVERY: DeliveryData
}

const TABS_ID_ATTR = `productTabs`

export const ProductDelivery = ({ ORDER_TYPE, DELIVERY }: ProductDeliveryProps): JSX.Element => {
	const tomorrow = dayjs().add(1, 'day').format('YYYY-MM-DD')

	const homeDate = dayjs(DELIVERY.HOME.DATE)
	const pickupDate = dayjs(DELIVERY.PICKUP.DATE)

	const isHomeToday = homeDate.isToday()

	const formatPrice = (price: number) => (price === 0 ? 'бесплатно' : `${price}₽`)

	const getHomeDeliveryText = () => {
		const isHomeToday = homeDate.isToday()
		const isHomeTomorrow = homeDate.format('YYYY-MM-DD') === tomorrow
		const todayPriceExists = typeof DELIVERY.HOME.TODAY_PRICE !== 'undefined'
		const priceExists = typeof DELIVERY.HOME.PRICE !== 'undefined'

		if (isHomeToday && (todayPriceExists || priceExists)) {
			return (
				<>
					<Text weight="regular" style={{ color: '#568dfe' }}>
						Доставка
					</Text>
					{!!DELIVERY.HOME.TODAY_PRICE && (
						<div className={cl.deliveryWrap}>
							<Text as="span" weight="medium">
								Сегодня
							</Text>
							, {DELIVERY.HOME.TODAY_PRICE}₽{' '}
							<Tip tooltipPosition={'bottom'} onXLPosition={'top'} Icon={<Question size={24} fill={'none'} />}>
								При оплате на сайте до 16:30, заказ от 15 000 ₽
							</Tip>
						</div>
					)}
					{priceExists && (
						<Text>
							<Text as="span" weight="medium">
								Завтра
							</Text>
							{DELIVERY.HOME.PRICE > 0 ? <>, {formatPrice(DELIVERY.HOME.PRICE)}</> : <>, Бесплатно</>}
						</Text>
					)}
				</>
			)
		}

		const deliveryDate =
			isHomeToday || isHomeTomorrow
				? 'завтра'
				: `к ${getLocalDateStringFromUTC(homeDate.toISOString(), { year: undefined, weekday: undefined })} `

		return (
			<>
				<Text style={{ color: '#568dfe' }}>
					Доставка{' '}
					<Text as="span" weight="medium">
						{deliveryDate}
					</Text>
				</Text>
				{DELIVERY.HOME.PRICE > 0 && <Text>, {formatPrice(DELIVERY.HOME.PRICE)}</Text>}
			</>
		)
	}

	const getShopsDeclension = (count: number): string =>
		count % 10 === 1 && count % 100 !== 11 ? 'магазина' : 'магазинов'

	const getPickupShopsMessage = (count: number): string => `${count} ${getShopsDeclension(count)}`

	const getPickupText = (): string => {
		const pickupFormatted = pickupDate.format('YYYY-MM-DD')
		const today = dayjs().format('YYYY-MM-DD')
		const shopsMessage = getPickupShopsMessage(DELIVERY.PICKUP.SHOPS_COUNT)

		return pickupFormatted === today
			? `сегодня из ${shopsMessage}`
			: pickupFormatted === tomorrow
			? `завтра из ${shopsMessage}`
			: `с ${getLocalDateStringFromUTC(pickupDate.toISOString(), {
					year: undefined,
					weekday: undefined
			  })} из ${shopsMessage}`
	}

	const shouldShowHomeDelivery =
		ORDER_TYPE === OrderType.PreOrder || ORDER_TYPE === OrderType.Order || ORDER_TYPE === OrderType.TCP

	return (
		<section className={cl.productDelivery}>
			<div>
				<div className={cl.regionButton}>
					<span>Получить&nbsp;&nbsp;в&nbsp;</span>
					<RegionSelector type={RegionType.Product} />
				</div>
				<Flex column rowGap={15}>
					{shouldShowHomeDelivery && DELIVERY.HOME.DATE && (
						<DeliveryItem deliveryModal isDelivery={isHomeToday} icon={<HomeIcon />}>
							{getHomeDeliveryText()}
						</DeliveryItem>
					)}
					{DELIVERY.PICKUP.DATE && (
						<DeliveryItem icon={<PackIcon />}>
							<Button theme="clear" onClick={() => scrollToTabSection(TABS_ID_ATTR, 'tab-pane-map')}>
								Самовывоз
							</Button>
							<Text weight="medium">&nbsp;{getPickupText()}</Text>
						</DeliveryItem>
					)}
					{DELIVERY.PVZ && (
						<DeliveryItem icon={<PinIcon />}>
							<Text weight="semibold">Пункты выдачи от 2 дней, 600 ₽</Text>
						</DeliveryItem>
					)}
				</Flex>
			</div>
		</section>
	)
}
